import { CircularProgress, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { useDebounce } from "../../../../../../hooks/useDebounce";

export default function SearchInput({
  label = "",
  selectedOption,
  onChangeSelectedOption = () => {},
  searchRequest = async () => {}
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 300);

  useEffect(() => {
    let isMounted = true;

    const handleRequest = async () => {
      if(!debouncedSearch) {
        setOptions([]);
        setLoading(false);
        return;
      }

      try {
        const response = await searchRequest(search);
        setOptions(response || []);
      } catch(error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }

    handleRequest();

    return () => { isMounted = false }
  }, [debouncedSearch]);

  const handleOpen = () => {
    if(!loading) {
      setLoading(true);
    }
    
    setIsOpen(true);
  }

  const handleClose = () => {
    if(loading) {
      setLoading(false);
    }
    
    setIsOpen(false);
  }

  const handleChangeInput = (search) => {
    if(!loading) {
      setLoading(true);
    }

    setSearch(search);
  }

  return (
    <Autocomplete
      open={isOpen}
      loading={loading}
      options={options}
      clearOnBlur={false}
      value={selectedOption}
      onChange={(_, newOption) => onChangeSelectedOption(newOption)}
      noOptionsText={`Nenhum resultado com "${search}"`}
      onOpen={handleOpen}
      onClose={handleClose}
      getOptionSelected={(option, value) => option?.id === value?.id}
      getOptionLabel={(option) => option.name || ''}
      inputValue={search}
      onInputChange={(_, value) => handleChangeInput(value)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
